export default __webpack_public_path__ + "static/media/land_type_footmountain.510e77c0.jpg";